import { Tab, styled } from "@mui/material";

const StyledTab = styled(Tab)(({ theme }) => ({
  fontSize: "14px",
  fontWeight: "600",
  lineHeight: "22px",
  textTransform: "none",
  color: theme.palette.custom.main,
}));

export default StyledTab;
